import { render, staticRenderFns } from "./LearnMoreLegal.vue?vue&type=template&id=44ea18ac"
import script from "./LearnMoreLegal.vue?vue&type=script&lang=js"
export * from "./LearnMoreLegal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.0__css-loader@3.6.0_webpa_3195bdfa917adf18e3c7373f63cbcb03/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports